interface IBuyPreviewState {
  cards: IBuyPreviewCards[];
}

export interface IBuyPreviewCards {
  title: string;
  iconSrc: string;
  href: string;
  links: IBuyPreviewLinks[];
  colWidth?: string;
  footerOrder: number;
}

interface IBuyPreviewLinks {
  title: string;
  href: string;
}

export const BuyPreviewState: IBuyPreviewState = {
  cards: [
    {
      title: 'BuyCrypto.Nav.Title',
      iconSrc: '/layout-images/header/buy-preview/arrow-down-outline.svg',
      href: '/buy-crypto',
      colWidth: '200',
      footerOrder: 1,
      links: [
        {
          title: 'BuyCrypto.Nav.BTC',
          href: '/sell-buy-crypto?coin=BTC&action=onramp',
        },
        {
          title: 'BuyCrypto.Nav.ETH',
          href: '/sell-buy-crypto?coin=ETH&action=onramp',
        },
        {
          title: 'BuyCrypto.Nav.LTC',
          href: '/sell-buy-crypto?coin=LTC&action=onramp',
        },
        {
          title: 'BuyCrypto.Nav.DOGE',
          href: '/sell-buy-crypto?coin=DOGE&action=onramp',
        },
        {
          title: 'BuyCrypto.Nav.20Plus',
          href: '/buy-crypto',
        },
      ],
    },
    {
      title: 'SellCrypto.Nav.Title',
      iconSrc: '/layout-images/header/buy-preview/arrow-up-outline.svg',
      href: '/buy-crypto',
      colWidth: '200px',
      footerOrder: 2,
      links: [
        {
          title: 'SellCrypto.Nav.BTC',
          href: '/sell-buy-crypto?coin=BTC&action=off_ramp',
        },
        {
          title: 'SellCrypto.Nav.ETH',
          href: '/sell-buy-crypto?coin=ETH&action=off_ramp',
        },
        {
          title: 'SellCrypto.Nav.LTC',
          href: '/sell-buy-crypto?coin=LTC&action=off_ramp',
        },
        {
          title: 'SellCrypto.Nav.DOGE',
          href: '/sell-buy-crypto?coin=DOGE&action=off_ramp',
        },
        {
          title: 'SellCrypto.Nav.20Plus',
          href: '/buy-crypto',
        },
      ],
    },
    {
      title: 'SwapCrypto.Nav.Title',
      iconSrc: '/layout-images/header/buy-preview/arrows-repeat-outline.svg',
      href: '/buy-crypto',
      colWidth: '200px',
      footerOrder: 3,
      links: [
        {
          title: 'SwapCrypto.Nav.BTC',
          href: '/sell-buy-crypto?coin=BTC&action=swap',
        },
        {
          title: 'SwapCrypto.Nav.ETH',
          href: '/sell-buy-crypto?coin=ETH&action=swap',
        },
        {
          title: 'SwapCrypto.Nav.LTC',
          href: '/sell-buy-crypto?coin=LTC&action=swap',
        },
        {
          title: 'SwapCrypto.Nav.DOGE',
          href: '/sell-buy-crypto?coin=DOGE&action=swap',
        },
        {
          title: 'SwapCrypto.Nav.20Plus',
          href: '/buy-crypto',
        },
      ],
    },
    // TODO: temporary hidden
    // {
    //   title: 'StoreCrypto.Nav.Title',
    //   iconSrc: '/layout-images/header/buy-preview/store.svg',
    //   href: '/',
    //   colWidth: '240px',
    //   footerOrder: 4,
    //   links: [
    //     {
    //       title: 'StoreCrypto.Nav.BTC',
    //       href: '/',
    //     },
    //     {
    //       title: 'StoreCrypto.Nav.ETH',
    //       href: '/',
    //     },
    //     {
    //       title: 'StoreCrypto.Nav.Tether',
    //       href: '/',
    //     },
    //     {
    //       title: 'StoreCrypto.Nav.LTC',
    //       href: '/',
    //     },
    //   ],
    // },
  ],
};
